const isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n);

export default isNumeric;


// WEBPACK FOOTER //
// ./src/utils/numbers/isNumeric.js